"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = exports.Action = void 0;
exports.reducer = reducer;
const constructors_union_1 = require("@genesys/client-core/lib/constructors-union");
const ts_exhaustive_check_1 = require("ts-exhaustive-check");
exports.Action = (0, constructors_union_1.ctorsUnion)({
    VariantListingSetSettings: (settings) => ({ settings }),
    VariantListingSetPropertyCollapsed: (propertyName) => ({
        propertyName
    }),
    VariantListingToggleLoader: () => ({}),
    VariantListingHideSettings: () => ({}),
    VariantListingToggleHideSettings: () => ({}),
    VariantListingSetMessagesAndResults: (messages, results) => ({
        messages,
        results
    }),
    VariantListingSetGenerationProgress: (inProgress, message, current, max) => ({ inProgress, message, current, max })
});
exports.initialState = {
    loading: false,
    hideAllSettings: false,
    generationProgress: {
        inProgress: false,
        message: "",
        current: 0,
        max: 0
    },
    settings: {
        systemTypeId: undefined,
        productId: undefined,
        rangeProperties: undefined,
        propertySelections: {}
    },
    messages: [],
    results: []
};
// biome-ignore lint: -
function reducer(state = exports.initialState, action) {
    switch (action.type) {
        case "VariantListingSetSettings": {
            return Object.assign(Object.assign({}, state), { settings: {
                    systemTypeId: action.settings.systemTypeId,
                    productId: action.settings.productId,
                    rangeProperties: action.settings.rangeProperties,
                    propertySelections: action.settings.propertySelections
                } });
        }
        case "VariantListingSetPropertyCollapsed": {
            const currentSelections = state.settings.propertySelections;
            let currenSelection = currentSelections[action.propertyName];
            currenSelection = Object.assign(Object.assign({}, currenSelection), { collapsed: !currenSelection.collapsed });
            currentSelections[action.propertyName] = currenSelection;
            return Object.assign(Object.assign({}, state), { settings: Object.assign(Object.assign({}, state.settings), { propertySelections: Object.assign({}, state.settings.propertySelections) }) });
        }
        case "VariantListingToggleLoader": {
            return Object.assign(Object.assign({}, state), { loading: !state.loading });
        }
        case "VariantListingSetGenerationProgress": {
            return Object.assign(Object.assign({}, state), { generationProgress: Object.assign(Object.assign({}, state.generationProgress), { inProgress: action.inProgress, message: action.message, current: action.current, max: action.max }) });
        }
        case "VariantListingSetMessagesAndResults": {
            return Object.assign(Object.assign({}, state), { messages: action.messages, results: action.results });
        }
        case "VariantListingToggleHideSettings": {
            return Object.assign(Object.assign({}, state), { hideAllSettings: !state.hideAllSettings });
        }
        case "VariantListingHideSettings": {
            return Object.assign(Object.assign({}, state), { hideAllSettings: true });
        }
        default: {
            (0, ts_exhaustive_check_1.exhaustiveCheck)(action);
        }
    }
    return state;
}
//# sourceMappingURL=variant-listing-state.js.map